module.exports = __webpack_public_path__ + "assets/img/tool4.7cc7aa15.png";